import { Link } from "react-router-dom";

export default function SocialButtonsHR({ routeUrl, isLogin }) {
  return (
    <>
      <Link
        to={routeUrl}
        className="btn btn-rounded btn-outline-primary btn-outline-email w-100 my-1 btn-icon-text">
        <i className="i-Mail-with-At-Sign" /> Sign {isLogin ? "in" : "up"} with Email
      </Link>
    </>
  );
}
